// extracted by mini-css-extract-plugin
export default {"recos":"R5-z","productCardOverride":"S5-z","rowHasBadge":"T5-z"};